<script>
import NavigationLink from '../common/header/NavigationLink.vue'
import {getLogoURLs} from "@/helpers/logo";
export default {
  components: {
    NavigationLink
  },
  data() {
    return {
      linkParams: {
        dashboard: {
          id: 'routeToDashboard',
          to: { name: 'dashboard' },
          restriction: () => true
        }
      }
    }
  },
  computed: {
    logoURL() {
      return getLogoURLs()
    },
  }
}
</script>
<template>
  <NavigationLink :link-params="linkParams.dashboard">
    <img
      id="logo-footer"
      :src="logoURL.footer"
      width="136"
      alt="footer logo"
    />
  </NavigationLink>
</template>
